import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Wrapper } from '../../components/wrapper.component';
import { getNotificationListOfTimeZonesUsed, notificationReselector } from '../../store/reselectors/apps.reselector';
import { TimeZoneDetails } from 'globals/store/programs.data';
import { getHHMMFromUTCTimeAndTimezoneId, getTimeZonedDateFromUTCTimeAndTimeZoneId, sleepForMS, urlIsValid } from '../../helpers/helpers';
import { AppNotification, AppNotificationType } from 'globals/store/app.data';
import { appLinkDropdownOptions } from '../../components/mobile/mobile-store/mobile.data';
import { findTimeZone, getUnixTime } from 'timezone-support';
import { FileLinkComponent } from 'src/app/components/file-handler/file-link.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { CommonModule } from '@angular/common';
import { TimeZonePickerComponent } from 'src/app/components/misc/timezone-picker.component';
import { DatePickerComponent } from 'src/app/components/misc/date-picker.component';
import { MatRadioModule } from '@angular/material/radio';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { FormsModule } from '@angular/forms';
import { jsonCopyObject } from 'globals/helpers/helpers';

@Component({
    selector: 'app-notification-dailog',
    template: `
<dialog-wrapper
  [backgroundColor]="'var(--primary)'"
  [disabled]="!notification.title || linkInvalid"
  [successLabel]=""
  [dialogTitle]="'Notification content'"
  [smallTitle]="true"
  [cancelLeft]="true"
  [showClose]="false"
  [maxHeight]="'unset'"
  [deleteLeft]="false"
  [data]="null"
  (cancel)="dialogRef.close()"
  (submit)="submit()"
  (delete)="deleteNotification()"
>
  <tip-text *ngIf="notification.pushTime - 3 * 60 * 1000 < time" [type]="'warn'" [head]="'Important:'" [body]="timingWarning"></tip-text>

  <mutating-input [object]="notification" [prop]="'title'" [placeholder]="'Notification title'"></mutating-input>
  <mutating-input [object]="notification" [prop]="'message'" [placeholder]="'Notification message'"></mutating-input>

  <mat-radio-group *ngIf="!!notification" name="notificationType" [(ngModel)]="notification.type">
    <mat-radio-button *ngFor="let type of notificationTypes"
      [value]="type"  
      (click)="notification.type === type ? null : notification.type = type">
      {{ notificationTypeNames[type] }}
    </mat-radio-button>
  </mat-radio-group>
  <div class="time">
    <div class="col">
      <h5 class="dateTitle">PUSH DATE</h5>
      <date-picker [pickedDate]="pushDate" (onDateChange)="pushDate = $event; changeTimeZone(notification.timeZone)"></date-picker>
    </div>
    <div class="col">
      <h5>PUSH TIME</h5>
      <input #timeInput type="time" id="timeInput" name="time" required (focusout)="changeTimeZone(notification.timeZone)"/>
    </div>
    <div class="col">
      <h5>TIME ZONE</h5>
      <timezone-picker *ngIf="!!timezones?.length" [timezones]="timezones" [selectedTimeZoneId]="notification.timeZone" (select)="changeTimeZone($event.timeZoneId)"></timezone-picker>
    </div>
  </div>

  <div class="time" *ngIf="notification?.type === 'linked'">
    <div class="col">
      <h5>Link Goes To</h5>
      <dropdown 
        [selections]="appLinkOptions" 
        [null_text]="'SELECT LINK TYPE'"
        [selected]="appLinkOptions | findById:notification.linkType" 
        (select)="notification.linkType = $event.id"
      ></dropdown>
    </div>

    <div class="col link" *ngIf="notification.linkType === 'URL'">
      <h5>URL Link</h5>
        <div class="invalid" *ngIf="!!linkInvalid">Link is invalid (needs to start with http(s)://)</div>
        <div class="link-holder">
          <joi-input  
            [(model)]="notification.linkUrl"
            [fixedWidth]="true"
            [placeholder]="'Link...'" 
            (joiChange)="checkLink()"
          ></joi-input>
          <file-link *ngIf="!linkInvalid && !!notification.linkUrl" [onlyLink]="true" [onlyOpenInNew]="true" [file]="{ linkUrl: notification.linkUrl }"></file-link>
        </div>
      </div>
    </div>
</dialog-wrapper>
  `,
    styleUrls: ['./app-notification-dialog.scss'],
    standalone: true,
    imports: [FileLinkComponent, JoiInputComponent, DropdownComponent, FindByIdPipe, CommonModule, TimeZonePickerComponent, DatePickerComponent, MatRadioModule, MutatingInputComponent, TipTextComponent, DialogWrapperComponent, CommonModule, FormsModule],
})

export class AppNotificationDialogComponent extends Wrapper<AppNotificationDialogComponent> implements OnInit {

  appLinkOptions = appLinkDropdownOptions
  notification: AppNotification
  notificationTypes: AppNotificationType[] = ['standard', 'linked']
  notificationTypeNames: { [t in AppNotificationType]: string } = { standard: 'Standard notification', linked: 'Notification with link'}
  timezones: TimeZoneDetails[] = []
  pushDate: Date
  linkInvalid: boolean
  timingWarning = "A notification set in the past or too close to now won't be sent as a notification (but it will still shown in the notifications section of the app).  To be sure it goes out as a notification, set it for more than three minutes in the future of the time you press 'ACTIVATE'."

  get time() { return new Date().getTime() }

  @ViewChild('timeInput') timeInput: ElementRef<HTMLInputElement>

  constructor(
    public dialogRef: MatDialogRef<AppNotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppNotificationDialogData
  ) { 
    super()
    this.selectProp(getNotificationListOfTimeZonesUsed, { appId: data.appId, notificationId: data.notificationId }, 'timezones')
    this.selectCallback(notificationReselector, { appId: data.appId, notificationId: data.notificationId }, notification => {
      this.notification = jsonCopyObject(notification) as AppNotification
      this.checkLink()
    })
  }



  async ngOnInit() {
    await sleepForMS(500)
    window['timeInput'] = this.timeInput
    this.pushDate = getTimeZonedDateFromUTCTimeAndTimeZoneId(this.notification.pushTime, this.notification.timeZone)
    this.setHHMM()
  }

  checkLink() {
    this.linkInvalid = !urlIsValid(this.notification.linkUrl)
  }

  setHHMM () {
    this.timeInput.nativeElement.value = getHHMMFromUTCTimeAndTimezoneId(this.notification.pushTime, this.notification.timeZone)
  }

 
  changeTimeZone(timeZoneId: string) {
    this.notification.timeZone = timeZoneId
    const [ hh, mm ] = this.timeInput.nativeElement.value.split(":")

    const time = {
      year: this.pushDate.getFullYear(),
      month: this.pushDate.getMonth() + 1,
      day: this.pushDate.getDate(),
      hours: parseInt(hh),
      minutes: parseInt(mm)
    }
    const timeZoneInfo = findTimeZone(timeZoneId)
    const unixTime = getUnixTime(time, timeZoneInfo)
    console.log({ time, hh, mm, timeZoneInfo, dateBefore: new Date(this.notification.pushTime), originalPushTime: this.notification.pushTime, unixTime, pushDate: this.pushDate })
    this.notification.pushTime = unixTime
    this.setHHMM()
  }

  submit() {
    this.changeTimeZone(this.notification.timeZone) // makes sure date is updated when only hh:mm has been updated
    this.dialogRef.close(this.notification)
  }

  deleteNotification() {
    console.log("DELETING? NOPE")
  }


}
export interface AppNotificationDialogData {
  appId: string
  notificationId: string
}

export interface NotificationDialogReturnData {

}